import React from 'react';
import { useAuth } from '../context/AuthContext';
import { ShieldAlert } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { canVisitPage } from '../services/pagePolicies';

export const PermissionGate = ({ permission, children, fallback }) => {
  const { hasPermission, user } = useAuth();
  const { pathname } = useLocation();
  
  if (!permission || (user?.legacy_access ? hasPermission(permission) : canVisitPage(user, pathname))) {
    return children;
  }

  if (fallback) return fallback;

  return (
    <div data-testid="permission-access-denied" role="alert" className="glass-card p-12 text-center animate-slide-in">
      <ShieldAlert className="w-16 h-16 mx-auto text-red-400 mb-4" />
      <h2 className="text-xl font-bold text-slate-800 mb-2">Access Denied</h2>
      <p className="text-slate-500 mb-4">You don't have permission to access this section.</p>
    </div>
  );
};

export default PermissionGate;
